import { getComparisonBasket } from 'helpers/web_to_client'

export const COMPARISON_BASKET_REQUEST_START = 'comparison_basket/REQUEST_START'
export const COMPARISON_BASKET_REQUEST_SUCCESS = 'comparison_basket/REQUEST_SUCCESS'
export const COMPARISON_BASKET_REQUEST_ERROR = 'comparison_basket/REQUEST_ERROR'

export function comparisonStatusRequestStart() {
    return {
        type: COMPARISON_BASKET_REQUEST_START,
    }
}

export function comparisonStatusRequestError() {
    return {
        type: COMPARISON_BASKET_REQUEST_ERROR,
    }
}

export function comparisonStatusRequestSuccess(data) {
    return {
        type: COMPARISON_BASKET_REQUEST_SUCCESS,
        payload: data,
    }
}

export function requestComparisonStatus() {
    return async (dispatch, getState) => {
        const { comparisonBasket } = getState()
        if (comparisonBasket.isLoading) return

        dispatch(comparisonStatusRequestStart())
        try {
            const data = await getComparisonBasket()
            dispatch(comparisonStatusRequestSuccess(data))
        } catch (error) {
            dispatch(comparisonStatusRequestError())
            // eslint-disable-next-line no-console
            console.error('>> WGSH Got error at the time of comparison basket request for update', error)
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/comparison_basket.js